
/* eslint-disable */


export default {
    PRINT_HINT_CONTENT: "请用浏览器打开下面网址：",
}

